import { render, staticRenderFns } from "./AtividadeAvaliativa.vue?vue&type=template&id=689901ec&"
import script from "./AtividadeAvaliativa.vue?vue&type=script&lang=js&"
export * from "./AtividadeAvaliativa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports